// extracted by mini-css-extract-plugin
module.exports = {"title":"AddLeadsModal_title__39kUE","addLeadsModal":"AddLeadsModal_addLeadsModal__yQoOC"};